import { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import Select from "react-select";
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../components/auth/useAuth'
import { getParameters } from '../../actions/parametersActions'
import Loader from '../../components/loaders/Loader'
import { updatePendingParams, getAnalisysWithPendings } from '../../actions/analisysActions'
import Swal from 'sweetalert2'

export default function ParametersInput({userType}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()

    const {analyses, resultAnalisys} = useSelector(state=>state.analises)
    const {parameters, loading} = useSelector(state=>state.parameters)

    const [parameterSeach, setParameterSeach] = useState(null)
    const [updates, setUpdates] = useState([])
    const [updateDone, setUpdatesDone] = useState([])

    useEffect(() => {
        if(clientauth){
            dispatch(getParameters())
        }
    }, [dispatch, t, clientauth])

    useEffect(() => {
        if(parameterSeach){
            dispatch(getAnalisysWithPendings(parameterSeach))
        }
    }, [parameterSeach])

    useEffect(() => {
        if(analyses){
            
        }
    }, [analyses])

    const updateSampleParam = (paramID, key, value) => {
        setUpdates(prev => {
            const exists = prev.find(p => p.paramID === paramID)

            if (exists) {
                return prev.map(p =>
                    p.paramID === paramID
                        ? { ...p, [key]: value }
                        : p
                )
            }

            // si no existe, lo añadimos
            return [...prev, { paramID, [key]: value }]
        })
    }

    const getUpdatedParam = (param) => {
        const found = updates.find(u => u.paramID === param._id)
        if (!found) return param

        return { ...param, ...found }
    }

    const enrichParamWithWorkOrder = (param, workOrder) => {
        const year = workOrder?.date ? new Date(workOrder.date).getFullYear() : null

        return {
            ...param,
            workOrderYear: year,
            workOrderNum: workOrder?.numWorkOrder ?? null,
            workOrderId: workOrder?._id ?? null,
        }
    }

    const handleSubmit = async(e) => {
        e.preventDefault()

        dispatch(updatePendingParams(updates))
    }
    
    useEffect(() => {
        if(resultAnalisys){
            let resultAnalisysTemp = resultAnalisys
            dispatch({ type: 'ANALISYS_RESET_RESULT'})
            switch (resultAnalisysTemp) {
                case 'editsuccessparams':
                    setUpdatesDone(updates.filter(u => u.status === 'done').map(u => u.paramID))

                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.analises.editsuccessparams')
                    })
                    break
                default:
                    break
            }
        }
    // eslint-disable-next-line
    }, [resultAnalisys])

    return (
        <Container className='mt-5 px-0'>
            <Row>
                <Col className='text-center'>
                    <h1>{t('admin.parameters.parametersInput')}</h1>
                </Col>
            </Row>
            <Row className='justify-content-start mb-3'>
                <Col xs={12} md={4} className='d-flex align-items-center'>
                    <Select
                        options={Array.from(parameters ?? []).sort((a, b) => a.name.localeCompare(b.name)).map(p => ({ value: p._id, label: p.name }))}
                        onChange={(selected) => setParameterSeach(selected?.value || "")}
                        isClearable
                        placeholder={t('admin.parameters.selectParameter')}
                    />
                </Col>
            </Row>
            {loading ?
                <Loader/>
            :
                <Row>
                    <Form onSubmit={handleSubmit} className="px-4 formulario">
                        <Col xs={12}>
                            {analyses?.length === 0 && parameterSeach &&
                                <p className="text-center">{t('admin.parameters.noPendingResults')}</p>
                            }
                            <Row>
                                <Col xs={6} md={1} className="d-flex align-items-center justify-content-center">{t('admin.analises.verified')}</Col>
                                <Col xs={6} md={2}>{t('admin.analises.enterSampleName')}</Col>
                                <Col xs={6} md={3}>{t('admin.parameters.parameter')}</Col>
                                <Col xs={6} md={3}>{t('admin.parameters.value')}</Col>
                                <Col xs={6} md={3}>{t('admin.parameters.batch')}</Col>
                            </Row>
                            {analyses?.map((analisys, index) =>
                                analisys?.measures?.map((measure, measureIndex) =>
                                    measure.params?.map((param, paramIndex) => {
                                        if (param.parameterReferenced !== parameterSeach || param.status === 'done' || updateDone?.includes(param._id)) return null

                                        const baseParam = enrichParamWithWorkOrder(param, analisys.workOrder)
                                        const mergedParam = getUpdatedParam(baseParam)

                                        return (
                                            <Row key={param._id} className="mb-2">
                                                <Col xs={6} md={1} className="d-flex align-items-center justify-content-center">
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={mergedParam.status !== 'pending'}
                                                        onChange={(e) =>
                                                            updateSampleParam(
                                                                param._id,
                                                                'status',
                                                                e.target.checked ? 'done' : 'pending'
                                                            )
                                                        }
                                                    />
                                                </Col>
                                                <Col xs={6} md={2} className="d-flex align-items-center">
                                                    <span>
                                                        {mergedParam.workOrderYear}-
                                                        {String(mergedParam.workOrderNum).padStart(4, "0")}-
                                                        {String(measure.sample).padStart(4, "0")}
                                                    </span>
                                                </Col>
                                                <Col xs={6} md={3} className="d-flex align-items-center">
                                                    <span className="ms-2">
                                                        {typeof mergedParam.parameter === "object"
                                                            ? mergedParam.parameter.name
                                                            : mergedParam.parameter}
                                                    </span>
                                                    <span className="ms-2">
                                                        ({mergedParam.minValue} {mergedParam.unitMeasure} -{" "}
                                                        {mergedParam.maxValue} {mergedParam.unitMeasure})
                                                    </span>

                                                </Col>
                                                <Col xs={6} md={3} className="d-flex align-items-center">
                                                    {userType === "Admin" ? (
                                                        mergedParam.value + " " + mergedParam.unitMeasure
                                                    ) : (
                                                        <>
                                                            <Form.Control
                                                                className="me-1"
                                                                type="number"
                                                                step="any"
                                                                value={mergedParam.value ?? ""}
                                                                onChange={(e) =>
                                                                    updateSampleParam(
                                                                        param._id,
                                                                        "value",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                style={{
                                                                    borderColor:
                                                                        mergedParam.value < mergedParam.minValue ||
                                                                        mergedParam.value > mergedParam.maxValue
                                                                            ? "red"
                                                                            : "",
                                                                    borderWidth:
                                                                        mergedParam.value < mergedParam.minValue ||
                                                                        mergedParam.value > mergedParam.maxValue
                                                                            ? "2px"
                                                                            : "",
                                                                }}
                                                                readOnly={mergedParam.status !== "pending"}
                                                            />
                                                            {mergedParam.unitMeasure}
                                                        </>
                                                    )}
                                                </Col>

                                                <Col xs={6} md={3}>
                                                    {userType === "Admin" ? (
                                                        mergedParam.batch || "-"
                                                    ) : (
                                                        <Form.Control
                                                            type="text"
                                                            value={mergedParam.batch ?? ""}
                                                            onChange={(e) =>
                                                                updateSampleParam(
                                                                    param._id,
                                                                    "batch",
                                                                    e.target.value
                                                                )
                                                            }
                                                            readOnly={mergedParam.status !== "pending"}
                                                        />
                                                    )}
                                                </Col>
                                            </Row>
                                        )
                                    })
                                )
                            )}
                        </Col>
                        <Col xs={12} className="my-2 ms-auto">
                            <Button variant='primary' type="submit" className="w-100 my-2">
                                <>{t('global.edit')}</>
                            </Button>
                        </Col>
                    </Form>
                </Row>
            }
        </Container>
    )
}